import { jsxs as f, Fragment as g } from "react/jsx-runtime";
import * as d from "react";
const p = "_title_9hxhg_1", l = {
  title: p
};
var b = /* @__PURE__ */ ((t) => (t.H1 = "h1", t.H2 = "h2", t.H3 = "h3", t.H4 = "h4", t.SPAN = "span", t))(b || {});
const _ = ({
  after: t = null,
  before: e = null,
  className: s = "",
  gtmEventLabel: a = null,
  noPadding: i = !1,
  regressionTag: r = null,
  smallHeaderOnMobile: o = !1,
  tag: u = "h2",
  testId: h = null,
  title: n,
  ...m
}) => {
  if (!n)
    return null;
  const c = d.createElement(
    u,
    {
      "data-testid": h,
      "data-gtm-event-label": a,
      "data-regression-tag": r,
      className: [
        l.title,
        s || "",
        i ? l.noPadding : "",
        o ? l.smallHeaderOnMobile : ""
      ].join(" "),
      ...m
    },
    n
  );
  return /* @__PURE__ */ f(g, { children: [
    e,
    c,
    t
  ] });
};
export {
  b as Header,
  _ as default
};
